import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { Collapse, Navbar, NavbarToggler, Nav, NavItem } from "reactstrap";

class Header extends Component {
  constructor() {
    super();
    this.state = {
      login: false,
      isOpen: true
    };

    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  componentWillMount = () => {
    if (localStorage.token) this.setState({ login: true });
  };

  handleLogout = async event => {
    localStorage.clear();
    this.props.history.push("/");
    this.toggle();
  };

  render() {
    return (
      <div>
        {window.localStorage.token ? (
          <Navbar
            color="light"
            light
            expand="md"
            className="fixed-top App-header"
          >
            <Link to="/">
              <img
                src={require(`../image/foodbook-logo.png`)}
                alt="Foodbook Logo"
                className="img-logo"
              />
            </Link>
            <NavbarToggler onClick={this.toggle} />
            <Collapse isOpen={!this.state.isOpen} navbar>
              <Nav className="ml-auto" navbar>
                <NavItem className="center">
                  <Link onClick={this.toggle} to="/" className="menu-sign mx-2">
                    Home
                  </Link>
                </NavItem>
                <NavItem className="center">
                  <Link
                    onClick={this.toggle}
                    to="/addfood"
                    className="menu-sign mx-2"
                  >
                    Add Food
                  </Link>
                </NavItem>
                <NavItem className="center">
                  <Link
                    onClick={this.toggle}
                    to="/profile"
                    className="menu-sign mx-2"
                  >
                    Profile
                  </Link>
                </NavItem>
                <NavItem className="center">
                  <Link
                    to="/signin"
                    className="menu-sign mx-2"
                    onClick={this.handleLogout}
                  >
                    Sign Out
                  </Link>
                </NavItem>
              </Nav>
            </Collapse>
          </Navbar>
        ) : (
          <Navbar
            className="fixed-top App-header"
            color="light"
            light
            expand="md"
          >
            <Link to="/">
              <img
                src={require(`../image/foodbook-logo.png`)}
                alt="Foodbook Logo"
                className="img-logo"
              />
            </Link>
            <NavbarToggler onClick={this.toggle} />
            <Collapse isOpen={!this.state.isOpen} navbar>
              <Nav className="ml-auto" navbar>
                <NavItem className="center">
                  <Link onClick={this.toggle} to="/" className="menu-sign mx-2">
                    Home
                  </Link>
                </NavItem>
                <NavItem className="center">
                  <Link
                    onClick={this.toggle}
                    to="/signin"
                    className="menu-sign mx-2"
                  >
                    Add Food
                  </Link>
                </NavItem>
                <NavItem className="center">
                  <Link
                    onClick={this.toggle}
                    to="/signin"
                    className="menu-sign mx-2"
                  >
                    Sign In
                  </Link>
                </NavItem>
                <NavItem className="center">
                  <Link
                    onClick={this.toggle}
                    to="/signup"
                    className="menu-sign mx-2"
                  >
                    Sign Up
                  </Link>
                </NavItem>
              </Nav>
            </Collapse>
          </Navbar>
        )}
      </div>
    );
  }
}

export default withRouter(Header);



// WEBPACK FOOTER //
// ./src/small/Header.jsx